import { Directive, HostListener, Input } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';

@Directive({
    selector: '[appAddRowOnTab]',
    standalone: false
})
export class AddRowOnTabDirective {
  @Input() tabbedColumnIndex: number;

  constructor(private readonly host: DxDataGridComponent) {}

  @HostListener('onEditorPreparing', ['$event']) onEditorPreparing(e) {
    if (e.parentType === 'dataRow') {
      const self = this;
      e.editorOptions.onKeyDown = e => {
        if (self.shouldAddNewRow(e, self.host)) {
          setTimeout(() => {
            self.host.instance.addRow();
          }, 100);
        }
      };
    }
  }

  shouldAddNewRow(e, grid) {
    return e.event.key === 'Tab' && this.isLastCellFocused(grid);
  }

  isLastCellFocused(grid) {
    return this.isLastRowFocused(grid) && this.isLastColumnFocused(grid);
  }

  isLastRowFocused(grid) {
    const focusedRowIndex = grid.focusedRowIndex;
    const rowsCount = grid.dataSource.length;
    if (rowsCount < 2) {
      return focusedRowIndex === rowsCount;
    }
    return focusedRowIndex === rowsCount - 1;
  }

  isLastColumnFocused(grid) {
    const focusedColumnIndex = grid.focusedColumnIndex;
    return focusedColumnIndex === this.tabbedColumnIndex;
  }
}
